export default __webpack_public_path__ + "static/media/Miami.0b594694.jpg";